<template>
    <v-container>
        <v-card :loading="loading">
            <v-img :src="require('../assets/sharks-3.jpg')"
                   height="160px"
            ></v-img>

            <v-card-title>
                Selecione os participantes
            </v-card-title>

            <v-card-subtitle>
                Selecione um arquivo separado por vírgulas (CSV) contendo a lista dos participantes
            </v-card-subtitle>
            <v-card-text>
                <vue-csv-import
                        :map-fields="['Nome', 'Email', 'Telefone', 'Curso']"
                        headers="true"
                        inputClass="v-input theme--dark v-text-field v-text-field--outlined primary--text"
                        tableClass="v-data-table"
                        v-model="parseCsv">

                    <template slot="hasHeaders" slot-scope="{headers, toggle}">
                        <v-switch
                                :label="`Contém Cabeçalhos:`"
                                @change="toggle"
                                v-model="hasHeaders"
                        ></v-switch>
                    </template>

                    <template slot="error">
                        <v-alert type="error">
                            Esse tipo de arquivo é inválido
                        </v-alert>
                    </template>

                    <template slot="thead">
                        <tr>
                            <th class="text-left">Sorteio</th>
                            <th class="text-left">Coluna do Arquivo</th>
                        </tr>
                    </template>

                    <template slot="next" slot-scope="{load}">
                        <v-btn @click.prevent="load">Escolher Campos</v-btn>
                    </template>
                </vue-csv-import>
                <v-switch v-model="suppressDuplicates" class="ma-2" label="Eliminar duplicados"></v-switch>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="parseCsv.length<1" :loading="loading" @click="prepareData()" large>Salvar e ir para o sorteio
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
	import {VueCsvImport} from 'vue-csv-import';
	import md5 from 'blueimp-md5-es6/js/md5'
	import {mapActions} from "vuex";
	import {nativeMath, shuffle} from "random-js";

	export default {
		components: {
			VueCsvImport
		},
		data: () => ({
			loading: false,
            suppressDuplicates: true,
			hasHeaders: true,
			parseCsv: [],
			list: [],
			slideType: 'cube',
			currentSlide: 0,
		}),
		created() {
		},
		computed: {},
		methods: {
			firstLastName(name) {
				// console.log('name ' ,name)
				name = name.trim()
				const parts = name.split(' ')
				if (parts.length === 1) {
					return this.capitalize(parts[0])
				} else {
					return this.capitalize(parts[0]) + ' ' + this.capitalize(parts[parts.length - 1])
				}
			},
			capitalize(input) {
				input = '' + input.toLowerCase()
				return input[0].toUpperCase() +
					input.slice(1)
			},
			mungeEmailAddress(s) {
				var i = s.indexOf('@');
				var startIndex = i * .2 | 0;
				var endIndex = i * .9 | 0;
				return s.slice(0, startIndex) +
					s.slice(startIndex, endIndex).replace(/./g, '*') +
					s.slice(endIndex);
			},
			prepareData() {
				this.loading = true
				var newData = []
				var self = this
				var luckyNumber = 1
                let found = undefined
				this.parseCsv.forEach(function (el) {
					// console.log(el)
					if (el.Email !== '' && el.Email !== undefined) {
						var obj = {}
						var email = el.Email.toLowerCase()
						obj.number = luckyNumber
						obj.hash = md5(email)
						obj.name = self.firstLastName(el.Nome)
                        obj.fullName = el.Nome
                        obj.phone = el.Telefone
						obj.email = email.toLowerCase()
						obj.hiddenEmail = self.mungeEmailAddress(email)
						obj.avatar = 'https://www.gravatar.com/avatar/' + obj.hash + '?s=96&d=robohash'
            obj.course = el.Curso
						luckyNumber++

						if (self.suppressDuplicates) {
							found = newData.find(element => element.email === email)
						}

						if (found === undefined) {
							newData.push(obj)
						}
					}
				})
				console.log('nova lista carregada: ', newData)
				// this.$store.commit('saveList', newData)
				shuffle(nativeMath, newData)
                this.saveList(newData)
                this.$router.push('/')
                this.loading = false
			},
			...mapActions(['saveList'])
		}
	}
</script>
<style lang="css">
    select {
        margin: 5px;
        padding: 15px;
        border: 1px solid;
        display: flex;
        flex-wrap: wrap;
        max-width: 100%;
        min-width: 0;
        cursor: pointer;
        align-items: flex-start;
        flex: 1 1 auto;
        font-size: 16px;
        letter-spacing: normal;
        text-align: left;
        border-radius: 4px;
        font-weight: 400;
        line-height: 1.375rem;
    }

    option {
        align-items: center;
        display: flex;
        flex: 1 1 100%;
        letter-spacing: normal;
        min-height: 48px;
        outline: none;
        padding: 0 16px;
        position: relative;
        text-decoration: none;
        background-color: gray;
    }
</style>

